import * as React from "react";
import cx from "classnames";

import { ShadowBox } from "../../../components";
import Summary from "../../WizardSummary";

import "./WizardFormLayout.css";

// There's probably better names than "left" and "right"...
export interface WizardFormLayoutProps {
  leftColPreMatter?: string;
  rightColPreMatter?: string;
  suppView?: React.ReactChild;
  formHeader?: React.ReactChild;
  actionBtn: React.ReactChild;
  children: React.ReactChild;
  hasTOC: boolean;
}

const getFormBoxClasses = ({ formHeader }: WizardFormLayoutProps) =>
  cx({
    "lift-pre-matter": formHeader != null,
  });

const WizardFormLayout = (props: WizardFormLayoutProps) => (
  <div className="wizard-form-layout">
    <div className="wizard-form-layout__ribbon-bg" />
    <div className="container">
      <div className="row wizard-form-layout__container">
        <div className="col-md-6 left-panel">
          <ShadowBox
            className={getFormBoxClasses(props)}
            preMatter={props.leftColPreMatter}
          >
            {props.formHeader ? props.formHeader : ""}
            {props.children}
          </ShadowBox>
        </div>
        <div className="col-md-6 right-panel">
          <ShadowBox
            className={getFormBoxClasses(props)}
            preMatter={props.rightColPreMatter}
          >
            <div className="shadow-box__action-container">
              {props.suppView || <Summary hasTOC={props.hasTOC} />}
              {props.actionBtn}
            </div>
          </ShadowBox>
        </div>
      </div>
    </div>
  </div>
);

export default WizardFormLayout;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/WizardFormLayout.tsx